"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));
var _Icons = _interopRequireDefault(require("./Icons"));
var _excluded = ["label", "className", "style", "id", "tabIndex", "description", "helperText", "extraContent"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CheckboxRadio = function CheckboxRadio(props) {
  var label = props.label,
    className = props.className,
    style = props.style,
    id = props.id,
    tabIndex = props.tabIndex,
    description = props.description,
    helperText = props.helperText,
    extraContent = props.extraContent,
    rest = _objectWithoutProperties(props, _excluded);
  var newID = id;
  if (newID === null) {
    newID = "box-" + rest.type + "-" + Math.floor(Math.random() * 100000000);
  }
  var classes = (0, _classnames["default"])("radio-checkbox", className);
  var hasDesc = description && description !== "" || extraContent;
  var labelClass = (0, _classnames["default"])({
    "descriptionLabel": hasDesc,
    "helperTextLabel": helperText && helperText !== "" && !hasDesc
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkboxRadio-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style,
    tabIndex: tabIndex,
    onKeyDown: function onKeyDown(event) {
      var key = _keyDownHandler["default"].getKeysFromEvent(event);
      if (key === _keyDownHandler["default"].keys.spacebar) {
        event.preventDefault();
        // Simulates onChange. we cannot just use the ref of the input and call onchange() on it.
        // the onchange is not defined at this place.
        props.onChange({
          target: {
            value: props.value,
            checked: !props.checked
          }
        });
      }
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-radio-checkbox"
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({}, rest, {
    id: newID
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: labelClass,
    htmlFor: newID,
    key: newID
  }, label, description && description !== "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "description"
  }, description), helperText && helperText !== "" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-helper-text"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "helper-text"
  }, helperText)), extraContent && extraContent !== "" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "extraContent"
  }, extraContent)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "check"
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "micro-glyph-checkmark"
  })))));
};
CheckboxRadio.propTypes = {
  type: _propTypes["default"].oneOf(["checkbox", "radio"]),
  name: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  value: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  extraContent: _propTypes["default"].any
};
CheckboxRadio.defaultProps = {
  type: "radio",
  name: "",
  value: "",
  label: null,
  checked: false,
  disabled: false,
  onChange: function onChange() {},
  className: "",
  style: {},
  tabIndex: 1,
  id: null,
  description: "",
  helperText: "",
  extraContent: null
};
var _default = exports["default"] = CheckboxRadio;